// NPM
import React, { useState, useEffect, useRef } from 'react'
import Slider from "react-slick"
import _ from 'lodash'

const Testimonials = ({ section, testimonials }) => {
   const sliderRef = useRef(null)

  if(!section) {
    return null;
  }

  const PrevArrow = () => {
    return (
      <button
        onClick={ () => sliderRef.current.slickPrev() }
        className="Testimonials__carousel-arrow">
          <img src={ require("src/images/icons/carousel-arrow-left.png").default } />
      </button>
    )
  }

  const NextArrow = () => {
    return (
      <button
        onClick={ () => sliderRef.current.slickNext() }
        className="Testimonials__carousel-arrow">
          <img src={ require("src/images/icons/carousel-arrow-right.png").default } />
      </button>
    )
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
  }

  return (
    <div className="Testimonials">
      <div className="Testimonials__content">
        <h4 className="Testimonials__title small-header">
          { section.title }
        </h4>

        <div className="Testimonials__carousel">
          <Slider ref={ sliderRef } { ...settings }>
            {
              _.sortBy(testimonials, "order").map((testimonial, testimonialIndex) => {
                return (
                  <div className="Testimonials__carousel-item" key={ `Testimonial-${ testimonialIndex }` }>
                    <p className="Testimonials__carousel-item-text">
                      { testimonial.quote }
                    </p>

                    <p className="Testimonials__carousel-item-credit">
                      { testimonial.credit }
                    </p>
                  </div>
                )
              })
            } 
          </Slider>
        </div>
        <div className="Testimonials__navigation">
          <PrevArrow />
          <NextArrow />
        </div>
      </div>
    </div>
  )

}

export default Testimonials